import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class Perimeter extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.perimeter',
        group: 'Spatial Operations',
        title: 'ST Perimeter',
        description: `
      This component adds a new column containing the perimeter of the geographies in the input table.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source polygons table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */
                  *, ST_PERIMETER(${connection.processInputGeogColumn(params.geo as string)})
                  AS ${params.geo}_perimeter
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle: {
        const geoColumn = params.geo as string
        const perimeterColumn = `${params.geo}_perimeter`
        return dedent`SELECT t.*,
                  SDO_GEOM.SDO_LENGTH(t.${geoColumn}, 0.005, 'unit=M') AS ${perimeterColumn}
                FROM ${connection.quoteName(params.source as string)} t`
      }
      default:
        return dedent`SELECT *, ST_PERIMETER(${connection.processInputGeogColumn(params.geo as string)})
                  AS ${params.geo}_perimeter
                FROM ${connection.quoteName(params.source as string)}`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_perimeter`,
      type: ColumnDataType.Number
    })
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { Perimeter }
